import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px 13px;
  gap: 8px;
  min-width: 226px;
`

export const Item = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const Label = styled.div`
  font-size: 16px;
  font-weight: 400;
`

export const Value = styled.div`
  font-size: 16px;
  font-weight: 400;
`
